module.exports = __webpack_public_path__ + "img/168.66a1a2ae.jpg";